import { HandlersCollection, Ref } from "@tblabs/truffle";
import { ThrottleConfig } from "./ThrottleConfig";


export class Throttle
{
    private timer: NodeJS.Timeout;
    private counter = new Ref<number>(0);
    private progressPercent = new Ref<number>(0);
    public OnCounterUpdate = new HandlersCollection<(counter: number, progressPercent: number) => void>();

    public get Delay(): number
    {
        return this.config.Interval * this.config.Steps;
    }

    public get Counter(): Ref<number>
    {
        return this.counter;
    }

    public get ProgressPercent(): Ref<number>
    {
        return this.progressPercent;
    }

    constructor(private config: ThrottleConfig)
    { }

    public get Step(): number
    {
        return this.config.Steps;
    }

    public Cancel(): this
    {
        if (this.timer)
        {
            clearTimeout(this.timer);

            this.counter.value = 0;
            this.progressPercent.value = 0;
            this.OnCounterUpdate.Call(this.counter);
        }

        return this;
    }

    public CallLater(handler: () => void): this
    {
        this.Cancel();

        this.timer = setInterval(() =>
        {
            this.counter.value += 1;
            // console.log('counter', this.counter.value);

            this.progressPercent.value = this.counter.value / this.Step * 100;

            this.OnCounterUpdate.Call(this.counter.value, this.progressPercent.value);

            if (this.counter.value >= this.config.Steps)
            {
                this.Cancel();
                handler();
            }
        }, this.config.Interval);

        return this;
    }
}
